var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
define(["require", "exports", "jquery", "knockout", "log", "../../utils/urls", "../../utils/tools", "../../utils/kendoUtils", "../../utils/dateUtils", "./reportBase"], function (require, exports, $, ko, log, urls_1, tools, KendoUtils, DateUtils, ReportBase) {
    "use strict";
    var CallLogs = /** @class */ (function (_super) {
        __extends(CallLogs, _super);
        function CallLogs() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.desktopColumns = [];
            _this.domainDepartments = ko.observableArray();
            _this.domainGroups = ko.observableArray();
            _this.domainExtensions = ko.observableArray();
            _this.selectedDomainGroups = ko.observableArray();
            _this.selectedDomainExtensions = ko.observableArray();
            _this.selectedDomainDepartments = ko.observableArray();
            _this.selectedCdrTypes = ko.observableArray();
            _this.selectedCdrStatus = ko.observableArray();
            _this.filterCdrByTimeFrom = ko.observable("");
            _this.filterCdrByTimeTo = ko.observable("");
            _this.filterCdrByNumberFrom = ko.observable("");
            _this.filterCdrByNumberTo = ko.observable("");
            _this.filterCdrByText = ko.observable("");
            _this.filterApplied = ko.observable(false);
            _this.filterInProgress = ko.observable(false);
            _this.reinitFilterTimer = 0;
            _this.reloadDataTimer = 0;
            _this.currentChartRange = ko.observable(0);
            _this.hours = ["00", "01", "02", "03", "04", "05", "06"];
            _this.minutes = ["00", "01", "02", "03", "04", "05", "06", "07", "08", "09", 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59];
            _this.mobileView = undefined;
            return _this;
        }
        CallLogs.prototype.init = function () {
            var self = this;
            $(window).off("resize.ace_hover");
            tools.ajaxGet({
                url: "/Reports/CallLogsLookupData",
                success: function (data) {
                    if (data.Success) {
                        self.lookupLists = data.Data.lookupLists;
                        self.domainList = data.Data.lookupLists.CdrDomains;
                    }
                    self.initMain();
                    self.setInitialFilter();
                    ko.applyBindings(self, document.getElementById("ko-main-content"));
                    if (!self.filterCdrByDomain()) {
                        self.filterCdrByDomain(data.Data.lookupLists.DefaultDomain);
                    }
                    self.initRest();
                    self.initGrid(self.lookupLists.GridStructures.CallLogsStructure);
                    $(".loader-container").hide();
                    $("#mainContext").show();
                }
            });
        };
        CallLogs.prototype.initGrid = function (gridStructure) {
            var self = this;
            var columns = gridStructure.columns;
            ko.utils.arrayForEach(columns, function (column) {
                if (!column.hidden) {
                    self.desktopColumns.push(column);
                }
            });
            self.mobileColumn = {
                field: "mobileField",
                title: "Call list",
                sortable: false,
                hidden: true,
                template: kendo.template($("#mobile-list-template").html())
            };
            columns.push(self.mobileColumn);
            self.mainTable = new KendoUtils.KendoUtils();
            var gridOptions = {
                dataSourceOptions: {
                    transport: {
                        read: {
                            url: "/Reports/GetCallLogsData",
                            type: "POST",
                            data: function () {
                                self.filterInProgress(true);
                                var data = {};
                                if (self.dateRangeType() === 99) {
                                    data.fromdate = DateUtils.toIsoString(self.filterCdrSummaryReportByStartDate());
                                    data.todate = DateUtils.toIsoString(self.filterCdrSummaryReportByEndDate());
                                }
                                else {
                                    data.fromdate = DateUtils.toIsoStringDate(self.filterCdrSummaryReportByStartDate());
                                    data.todate = DateUtils.toIsoStringDate(self.filterCdrSummaryReportByEndDate());
                                }
                                if (self.filterCdrByDomain()) {
                                    data.domain = self.filterCdrByDomain();
                                }
                                if (self.filterCdrByText()) {
                                    data.searchText = self.filterCdrByText();
                                }
                                data.periodType = self.dateRangeType();
                                data.callTypes = self.selectedCdrTypes().join(",");
                                data.statuses = self.selectedCdrStatus().join(",");
                                data.groups = self.selectedDomainGroups().join(",");
                                data.extensions = self.selectedDomainExtensions().join(",");
                                var selectedDepartments = self.selectedDomainDepartments().join(",");
                                if (data.extensions) {
                                    if (selectedDepartments) {
                                        data.extensions += ",".concat(selectedDepartments);
                                    }
                                }
                                else {
                                    data.extensions = selectedDepartments;
                                }
                                if (self.filterCdrByTimeFrom() !== "00:00:00" || self.filterCdrByTimeTo() !== "00:00:00") {
                                    data.totalTimeFrom = self.filterCdrByTimeFrom();
                                    data.totalTimeTo = self.filterCdrByTimeTo();
                                }
                                data.fromNumber = self.filterCdrByNumberFrom();
                                data.toNumber = self.filterCdrByNumberTo();
                                return data;
                            },
                            dataType: "json"
                        }
                    },
                    serverPaging: true,
                    serverFiltering: true,
                    serverSorting: true,
                    serverAggregates: true,
                    schema: {
                        model: gridStructure.model,
                        data: function (response) { return response.Data; },
                        total: "Total",
                        aggregates: "Aggregates",
                        errors: "Errors"
                    },
                    sort: { field: "Start", dir: "desc" }
                },
                gridOptions: {
                    columns: columns,
                    autoBind: false,
                    resizable: true,
                    selectable: false,
                    height: "400px",
                    dataBound: function () {
                        //self.filterInProgress(false);
                        //$("button[data-action='applyFilter']").button("reset");
                    },
                    detailTemplate: kendo.template($("#call-details-template").html())
                },
                enableExport: {
                    entityName: "CallDetailsReport",
                    title: "Call Logs",
                    enablePdf: false
                },
                allowBulkEdits: {
                    enabled: false
                },
                autoHeight: {
                    totalOffset: 222 + 90
                },
                enableStickyHeader: false,
                gridId: "tblCallLogs",
                showPagerOnTop: false,
                customLoading: true,
                controller: self
            };
            self.mainTable.initGrid(gridOptions);
            var resizeEvent;
            $(window).resize(function () {
                if (resizeEvent) {
                    clearTimeout(resizeEvent);
                }
                resizeEvent = setTimeout(function () {
                    self.updateCulumnsVisibilityOnResize();
                }, 100);
            });
            self.updateCulumnsVisibilityOnResize();
            $("#tblCallLogs").on("click", ".k-master-row", function (event) {
                var row = $(event.currentTarget).closest("tr");
                self.collapseAllKendoGridDetailRows('tblCallLogs', row);
                setTimeout(function () {
                    var link = row.find("td.k-hierarchy-cell .k-icon");
                    link.click();
                });
            }).on("click", ".toggle-flow-details", function (event) {
                var row = $(event.currentTarget).closest(".mobile-list");
                var details = $('.flow-details', row);
                details.toggle();
            });
        };
        CallLogs.prototype.updateCulumnsVisibilityOnResize = function () {
            var self = this;
            var grid = self.mainTable.getGridData();
            var currentView = window.innerWidth < 1150;
            if (currentView === self.mobileView) {
                return;
            }
            self.mobileView = currentView;
            if (self.mobileView) {
                ko.utils.arrayForEach(self.desktopColumns, function (column) {
                    grid.hideColumn(column.field);
                });
                //grid.hideColumn(0);
                grid.showColumn(self.mobileColumn.field);
                grid.setOptions({
                    detailTemplate: null
                });
            }
            else {
                //grid.showColumn(0);
                grid.hideColumn(self.mobileColumn.field);
                ko.utils.arrayForEach(self.desktopColumns, function (column) {
                    grid.showColumn(column.field);
                });
                grid.setOptions({
                    detailTemplate: kendo.template($("#call-details-template").html())
                });
            }
        };
        CallLogs.prototype.collapseAllKendoGridDetailRows = function (prmGridId, rowToIgnore) {
            //Get a collection of all rows in the grid
            var grid = $('#' + prmGridId).data('kendoGrid');
            var allMasterRows = grid.tbody.find('>tr.k-master-row');
            //Loop through each row, if a row has a detail row following it then collapse that master row
            for (var i = 0; i < allMasterRows.length; i++) {
                var row = allMasterRows.eq(i);
                if (row.is(rowToIgnore)) {
                    continue;
                }
                if (row.next('tr.k-detail-row').length > 0) {
                    grid.collapseRow(row);
                }
            }
        };
        CallLogs.prototype.setInitialFilter = function () {
            var self = this;
            var domain = urls_1.urls.getQueryString("domain");
            var fromdate = urls_1.urls.getQueryString("fromdate");
            var todate = urls_1.urls.getQueryString("todate");
            if (domain) {
                var availableDomain = ko.utils.arrayFirst(self.domainList, function (item) {
                    return item === domain;
                });
                if (availableDomain) {
                    self.filterCdrByDomain(availableDomain);
                }
            }
            if (fromdate) {
                self.filterCdrSummaryReportByStartDate(kendo.parseDate(fromdate));
            }
            if (todate) {
                self.filterCdrSummaryReportByEndDate(kendo.parseDate(todate));
            }
        };
        CallLogs.prototype.updateGroupExtensionFilter = function () {
            var self = this;
            var group = urls_1.urls.getQueryString("group");
            var extension = urls_1.urls.getQueryString("extension");
            if (group) {
                self.selectedDomainGroups.push(group);
            }
            if (extension) {
                self.selectedDomainExtensions.push(extension);
            }
        };
        CallLogs.prototype.initRest = function () {
            var self = this;
            var dropdown = $("#domainsList").data("kendoDropDownList");
            dropdown.value(self.filterCdrByDomain());
            self.filterCdrByText.extend({ rateLimit: 800 }).subscribe(function () {
                self.filterApplied(false);
                self.applyFilter();
            });
            $("#cbFilterNumberFrom").kendoMaskedTextBox();
            $("#cbFilterNumberTo").kendoMaskedTextBox();
            /*$("#cbFilterTimeFrom").kendoMaskedTextBox({
                mask: "00:~0:~0",
                rules: {
                    "~": /[012345]/
                },
                promptChar: "0",
                clearPromptChar: false
            });
    
            $("#cbFilterTimeTo").kendoMaskedTextBox({
                mask: "00:~0:~0",
                rules: {
                    "~": /[012345]/
                },
                promptChar: "0",
                clearPromptChar: false
            });*/
        };
        CallLogs.prototype.onDomainChanged = function () {
            var self = this;
            self.selectedDomainGroups([]);
            self.selectedDomainExtensions([]);
            self.selectedDomainDepartments([]);
            self.updateGroupExtensionFilter();
            self.getDomainAccounts(self.filterCdrByDomain());
            _super.prototype.onDomainChanged.call(this);
        };
        CallLogs.prototype.getDomainAccounts = function (domain) {
            var self = this;
            tools.ajaxPost({
                url: "/Reports/GetExtensionsFilterData",
                data: { domain: domain },
                success: function (data) {
                    if (data.Data) {
                        self.domainExtensions(data.Data.Extensions);
                        self.domainGroups(data.Data.Groups);
                        self.domainDepartments(data.Data.Departments);
                    }
                }
            });
        };
        CallLogs.prototype.openFilterDialog = function () {
            $("#filterLogsDialog").modal("show");
        };
        CallLogs.prototype.filterClicked = function () {
            var self = this;
            var groups = $("input:checkbox[name=filterByGroup]:checked").map(function (index, element) { return $(element).val(); }).get();
            self.selectedDomainGroups(groups);
            var extensions = $("input:checkbox[name=filterByExtension]:checked").map(function (index, element) { return $(element).val(); }).get();
            self.selectedDomainExtensions(extensions);
            var departments = $("input:checkbox[name=filterByDepartment]:checked").map(function (index, element) { return $(element).val(); }).get();
            self.selectedDomainDepartments(departments);
            var types = $("input:checkbox[name=filterByType]:checked").map(function (index, element) { return $(element).val(); }).get();
            self.selectedCdrTypes(types);
            var statuses = $("input:checkbox[name=filterByStatus]:checked").map(function (index, element) { return $(element).val(); }).get();
            self.selectedCdrStatus(statuses);
            var timeFromValue = $("#cbFilterTimeFrom select[name=hour]").val() + ":" + $("#cbFilterTimeFrom select[name=minute]").val() + ":" + $("#cbFilterTimeFrom select[name=second]").val();
            var timeToValue = $("#cbFilterTimeTo select[name=hour]").val() + ":" + $("#cbFilterTimeTo select[name=minute]").val() + ":" + $("#cbFilterTimeTo select[name=second]").val();
            self.filterCdrByTimeFrom = ko.observable(timeFromValue);
            self.filterCdrByTimeTo = ko.observable(timeToValue);
            var numberFromTextbox = $("#cbFilterNumberFrom").data("kendoMaskedTextBox");
            var numberFromValue = numberFromTextbox.value();
            var numberToTextbox = $("#cbFilterNumberTo").data("kendoMaskedTextBox");
            var numberToValue = numberToTextbox.value();
            self.filterCdrByNumberFrom = ko.observable(numberFromValue);
            self.filterCdrByNumberTo = ko.observable(numberToValue);
            $("#filterLogsDialog").modal("hide");
            self.applyFilter();
        };
        CallLogs.prototype.applyFilter = function () {
            _super.prototype.applyFilter.call(this);
            var self = this;
            if (self.reloadDataTimer > 0) {
                clearTimeout(self.reloadDataTimer);
                log.log("clear grid request");
            }
            self.reloadDataTimer = setTimeout(function () {
                log.log("execute grid request");
                self.mainTable.getGridData().dataSource.page(1);
            }, 300);
        };
        CallLogs.prototype.clearFilter = function () {
            _super.prototype.clearFilter.call(this);
            var self = this;
            self.selectedDomainGroups([]);
            self.selectedDomainExtensions([]);
            self.selectedDomainDepartments([]);
            self.filterCdrSummaryReportByStartDate(DateUtils.addDays(DateUtils.today(), -1));
            self.filterCdrSummaryReportByEndDate(DateUtils.addDays(DateUtils.today(), -1));
            self.filterCdrByDomain(self.domainList[0]);
        };
        CallLogs.prototype.exportTo = function () {
            var self = this;
            if (self.canExport()) {
                self.mainTable.exportToMaterial();
            }
        };
        return CallLogs;
    }(ReportBase));
    setTimeout(function () {
        if (urls_1.urls.startsWith("/Reports/CallLogs")) {
            log.log("Initialize CallLogs list");
            $(function () {
                (new CallLogs()).init();
            });
        }
    }, 0);
    return CallLogs;
});
//# sourceMappingURL=callLogs.js.map


//////////////////
// WEBPACK FOOTER
// ./build/areas/reports/callLogs.js
// module id = 253
// module chunks = 2